<template>
    <div>
        <Topbar/>
        <Sidebar/>

        <router-view></router-view>
    </div>
</template>

<script>
import Topbar from '@/components/common/layout/Topbar';
import Sidebar from '@/components/common/layout/Sidebar';

    export default {
        name: 'default-layout',
        components: {
            Topbar,
            Sidebar
        }
    }
</script>
